// extracted by mini-css-extract-plugin
export default {"main":"style_main__M+XFM","container":"style_container__APvxo","lineContainer":"style_lineContainer__65q9L","header":"style_header__jIUKn","qrCodeBox":"style_qrCodeBox__krdVr"};